<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-05 16:27:37
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-08 17:52:38
 * @Description: 项目详情
 -->
<template>
  <div>
    <div class="base-data-wrapper">
      <div class="content-wrapper">
        <h3 class="title">项目介绍</h3>
        <div class="content">
          <p class="text">
            {{ baseInfo.projectDetail }}
          </p>
        </div>
      </div>
      <div class="content-wrapper">
        <h3 class="title">借款人信息</h3>
        <div class="content">
          <div class="item-row">
            <span class="item-label">借款人姓名：</span>
            <span>{{ userInfo ? userInfo.userName : '' }}</span>
          </div>
          <div class="item-row">
            <span class="item-label">身份证号码：</span>
            <span>{{ userInfo ? userInfo.identityId : '' }}</span>
          </div>
          <div class="item-row">
            <span class="item-label">性别：</span>
            <span>{{ userInfo ? userInfo.sex : '' }}</span>
          </div>
          <div class="item-row">
            <span class="item-label">月收入：</span>
            <span>{{ userInfo ? userInfo.income : '' }}</span>
          </div>

          <div class="item-row">
            <span class="item-label">所属行业：</span>
            <span>{{ userInfo ? userInfo.industry : '' }}</span>
          </div>

          <div class="item-row">
            <span class="item-label">借款用途：</span>
            <span>{{ userInfo ? userInfo.usage : '' }}</span>
          </div>

          <div class="item-row">
            <span class="item-label">还款来源：</span>
            <span>个人收入</span>
          </div>

          <div class="item-row">
            <span class="item-label">近6个月内征信预期情况：</span>
            <span>{{ userInfo ? userInfo.overdueInSixMonth : '' }}</span>
          </div>

          <div class="item-row">
            <span class="item-label">借款人负债情况：</span>
            <span>{{ userInfo ? userInfo.IsDebt : '' }}</span>
          </div>
          <div class="item-row">
            <span class="item-label">借款人主体性质：</span>
            <span>{{ userInfo ? userInfo.userType : '' }}</span>
          </div>
          <div class="item-row">
            <span class="item-label">在其他网络借贷平台借款情况：</span>
            <span> {{ userInfo ? userInfo.otherLoan : '' }}（此项由借款人自述）</span>
          </div>
        </div>
      </div>
      <div class="content-wrapper">
        <h3 class="title">基本信息</h3>
        <div class="content">
          <div class="item-row">
            <span class="item-label">项目名称：</span>
            <span>{{ baseInfo.name }}</span>
          </div>
          <div class="item-row">
            <span class="item-label">项目总额：</span>
            <span>{{ baseInfo.money }}</span>
          </div>
          <div class="item-row">
            <span class="item-label">还款方式：</span>
            <span>{{ baseInfo.repayWay }}</span>
          </div>
          <div class="item-row">
            <span class="item-label">起息日期：</span>
            <span>{{ baseInfo.interestAccrual }}</span>
          </div>

          <div class="item-row">
            <span class="item-label">推出限制：</span>
            <span>不可提前退出</span>
          </div>

          <div class="item-row">
            <span class="item-label">是否有担保：</span>
            <span>否</span>
          </div>
        </div>
      </div>
      <div class="content-wrapper">
        <h3 class="title">项目资金运用情况</h3>
        <div class="content">
          <div class="item-row">
            <span class="item-label">项目资金运用情况：</span>
            <span>无变化</span>
          </div>
          <div class="item-row">
            <span class="item-label">借款人经营情况：</span>
            <span>无变化</span>
          </div>
          <div class="item-row">
            <span class="item-label">借款人财务状况：</span>
            <span>{{ userInfo ? userInfo.hasOverdue : '' }}</span>
          </div>
          <div class="item-row">
            <span class="item-label">借款人逾期情况：</span>
            <span>暂无</span>
          </div>

          <div class="item-row">
            <span class="item-label">借款人涉诉情况：</span>
            <span>无变化</span>
          </div>

          <div class="item-row">
            <span class="item-label">借款人还款能力变化：</span>
            <span>无变化</span>
          </div>
          <div class="item-row">
            <span class="item-label">借款人受行政处罚情况可能影响：</span>
            <span>暂无</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'base-data',
  data() {
    return {
      title: '项目介绍',
      baseInfo: {},
      userInfo: {},
      userType: {
        '0': '平台',
        '1': '自然人',
        '2': '法人'
      }
    };
  },
  created() {
    if (this.$route.params.flag === '1') {
      this.requestDetail();
    } else {
      this.requestNo1Detail();
      return;
    }
  },
  mounted() {
    // this.$eventBus.$emit('listBarTitle', this.title);
  },
  methods: {
    async requestDetail() {
      const res = await this.$http.post('cg/commonRequest', {
        method: 'project.pc.detail',
        projectid: this.$route.params.id
        // flag: this.$route.params.flag
      });
      if (res.code === 200) {
        const data = res.data;
        console.log(data);
        this.baseInfo = {
          name: data.project_name,
          code: data.project_code,
          money: data.moneys,
          remainMoney: data.redius_money,
          currentMoney: parseFloat(data.moneys - data.redius_moneys).toFixed(2),
          progress: parseFloat((data.moneys - data.redius_moneys) / data.redius_moneys).toFixed(2),
          projectDetail: data.desc.projectDetail,
          period: data.period,
          annualRate: data.annual_rate,
          interestAccrual: data.interest_accrual,
          repayWay: data.repay_way,
          createTime: data.c_time,
          isGuarantee: data.is_guarantee === 1 ? '是' : '否',
          costTime: Math.ceil(
            (new Date(data.full_time).getTime() - new Date(data.sell_time).getTime()) / 24 / 3600000
          ) // 满标用时
        };
        this.userInfo = {
          ...data.debtInfo,
          userName: data.desc.projectUser.username,
          sex: data.desc.projectUser.sex,
          identityId: data.desc.projectUser.identityid,
          usage: data.usage,
          userType: this.userType[`${data.desc.projectUser.user_type}`],
          industry: data.desc.projectUser.industry,
          income: data.desc.projectUser.income,
          overdueInSixMonth: data.debtInfo.creditReporting.substr(4, 3),
          hasOverdue: '未逾期'
        };
        // console.log(this.userInfo);
      }
    },
    // 鲸鱼一号
    async requestNo1Detail() {
      const res = await this.$http.post('/cg/commonRequest', {
        method: 'oproject.detail',
        projectid: this.$route.params.id
      });
      if (res.code === 200) {
        const data = res.data;
        this.baseInfo = {
          name: data.detail.project_name,
          code: data.applyRecord.contract_no,
          money: data.detail.finance_money,
          remainMoney: data.detail.dropTankMoney,
          currentMoney: parseFloat(data.invested_money - data.redius_moneys).toFixed(2),
          progress: data.detail.process_width.toFixed(2),
          projectDetail: data.detail.description,
          period: data.detail.project_period,
          annualRate: data.detail.rate_init,
          interestAccrual: data.detail.interest_accrual,
          repayWay: data.detail.repay_way,
          createTime: data.detail.c_time,
          isGuarantee: data.is_guarantee === 1 ? '是' : '否',
          costTime: data.full.fullNum
        };
        this.userInfo = {
          ...data.debtInfo,
          userName: data.applyRecord.base_info.base_realName,
          sex: data.applyRecord.base_info.base_sex === 1 ? '男' : '女',
          identityId: data.applyRecord.base_info.base_identityid,
          usage: data.applyRecord.base_info.base_usage,
          userType: this.userType[`${data.applyRecord.base_info.user_type}`],
          industry: data.detail.industry,
          income: data.applyRecord.base_info.income,
          // overdueInSixMonth: data.applyRecord.creditReporting.substr(4, 3),
          overdueInSixMonth: data.applyRecord.creditReporting,
          hasOverdue: '未逾期'
        };
      }
    }
  }
};
</script>
<style lang="less" scoped>
.base-data-wrapper {
  background: #fff;
  height: 100%;
  padding: 0 0.38rem;
  .content-wrapper {
    padding: 0.3rem 0 0.7rem;
    font-size: 0.24rem;
    color: #999999;
    h3 {
      font-size: 0.3rem;
      line-height: 0.3rem;
      color: #333333;
      margin-bottom: 0.38rem;
      &::before {
        content: '';
        width: 0.09rem;
        height: 0.3rem;
        background-color: #0d72e2;
        display: inline-block;
        vertical-align: top;
        margin-right: 0.28rem;
      }
    }
    .item-row {
      line-height: 2;
    }
  }
  .row {
    padding: 20px 0;
    box-sizing: border-box;
  }
  .label {
    text-align: right;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #6a6a6a;
    line-height: 26px;
  }
  .text-box {
    font-family: 'PingFangSC-Thin';
    font-size: 12px;
    color: #6a6a6a;
    line-height: 26px;
  }
}
</style>
